export default {
  'express-checkout:page-title': 'Bestelling afronden',
  'express-checkout:cart-items:size': 'Maat',
  'express-checkout:cart-items:remove': 'Verwijderen',
  'express-checkout:header': 'Wil je je aankoop echt annuleren en terug naar de winkelwagen?',
  'express-checkout:header:button-continue': 'Verder winkelen',
  'express-checkout:header:button-to-cart': 'Naar de winkelwagen',
  'express-checkout:summary-prices:not-use-discount': 'Niet gebruiken',
  'express-checkout:summary-prices:use-discount': 'Gebruiken',
  'express-checkout:confirm:error-message': 'Helaas is er iets misgegaan bij het betalen.',
  'express-checkout:confirm:thank-you-message:header': 'Bedankt voor je bestelling',
  'express-checkout:confirm:thank-you-message:sub-header':
    'We laten het je weten zodra je zending onderweg is naar je toe.',
  'express-checkout:confirm:button-continue-shopping': 'Verder snuffelen',
  'express-checkout:summary-form:shipping-and-payment:shipping': 'Verwachte levering',
  'express-checkout:summary-form:shipping-and-payment:extra-options': 'Extra opties',
  'express-checkout:summary-form:shipping-and-payment:eco-option': 'Eco optie',
  'express-checkout:summary-form:shipping-and-payment:eco-option-point-1':
    'Milieuvriendelijke isolatieverpakking van gerecyclede PET-wol',
  'express-checkout:summary-form:shipping-and-payment:eco-option-point-2':
    'Duurzaam en volledig recyclebaar',
  'express-checkout:summary-form:re-auth-loading-message':
    'Het verwerken van de betaling kan enkele seconden duren.',
  'express-checkout:summary-form:addresses:complete-address':
    'Vul je adres aan voordat je betaalt.',
};
